import angular from "angular";

angular
    .module('app')
    .component('packetStudentsAttachModal', {
        template: require('./packet-students-attach-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', 'moment','RequestsQueue', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope, moment,RequestsQueue) {

    let $ctrl = this;

    $ctrl.page = 1;

    $ctrl.search = null;

    $ctrl.totalSelect = false;

    $ctrl.selectedStudents = [];

    $ctrl.$onInit = function () {
        $ctrl.packet = $ctrl.resolve.packet;

        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $ctrl.loading = true;

        $http
            .get(`/admin/users/get-list`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                }
            })
            .then(res => {
                $ctrl.students = res.data.data;

                $ctrl.total = res.data.total;

                $ctrl.students.forEach(function (student) {
                    let exists = $ctrl.selectedStudents.find(v => v.id == student.id);
                    student.isSelected = !!exists;
                });
            })
            .catch(err => {

            })
            .finally(() => {
                $ctrl.loading = false;
            })
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.totalSelect = false;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.totalSelect = false;
        $ctrl.getList();
    };

    $ctrl.perPageChanged = function () {
        $ctrl.totalSelect = false;
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.pageChanged = function () {
        $ctrl.totalSelect = false;
        $ctrl.getList();
    };

    $ctrl.userSelected = function (student) {
        if (student.isSelected) {
            $ctrl.selectedStudents.push(student);
        } else {
            delStudentFromSelected(student);
        }
    };

    $ctrl.totalSelectChanged = function () {
        if ($ctrl.totalSelect) {
            $ctrl.students.forEach(function (student) {
                if (!student.course_status && !student.isSelected) {
                    student.isSelected = true;
                    $ctrl.selectedStudents.push(student);
                }
            });
        } else {
            $ctrl.students.forEach(function (student) {
                if (!student.course_status && student.isSelected) {
                    student.isSelected = false;
                    delStudentFromSelected(student);
                }
            });
        }
    };

    function delStudentFromSelected(student) {
        let existsInd = $ctrl.selectedStudents.findIndex(v => v.id == student.id);
        if (existsInd != -1) {
            $ctrl.selectedStudents.splice(existsInd, 1);
        }
    }

    $ctrl.submit = function () {

        if ($ctrl.attachLoading) {
            return;
        }

        let students = $ctrl.selectedStudents.filter(v => !v.attached);

        if (!students.length) {
            return;
        }

        $ctrl.attachErrors = [];

        $ctrl.attachLoading = true;

        $ctrl.attachQueue = RequestsQueue();

        $ctrl.attachQueue.setFinishCallback(function () {
            $ctrl.attachLoading = false;
        });

        students.forEach(function (student) {
            $ctrl
                .attachQueue
                .add({
                    method: 'POST',
                    url: `/admin/packets/${$ctrl.packet.id}/attach-student`,
                    data: {user_id: student.id}
                })
                .then(
                    function (response) {
                        student.attached = true;
                        $ctrl.hasAttached = true;
                    },
                    function (error) {
                        $ctrl.attachErrors.push({student, data: error.data});
                    }
                );
        });
    };

    $ctrl.dismissModal = function () {
        if ($ctrl.attachLoading) {
            if (confirm('Вы действительно хотите закрыть окно?')) {
                if ($ctrl.attachLoading) {
                    $ctrl.attachQueue.clear();
                }
                $ctrl.close();
            }
        } else {
            if ($ctrl.hasAttached) {
                $ctrl.close();
            } else {
                $ctrl.dismiss();
            }
        }
    };
}
